import React from 'react'
import "./InfoBox.css"

const InfoBox = ({heading,buttons,customeHeadWidth, redTitle,children}) => {
  return (
    <>
        <div className="info-box-wrapper gray-box">

            <div className="info-box">
                <div className="box-head" style={{borderBottom: "1px solid #DEE2E6"}}>
                    <div className="head-col-1" style={{flex:`0 0 ${customeHeadWidth}` , color: redTitle ? "red" : ""}}>
                      {heading}
                    </div>
                    <div className="head-col-2">
                      {buttons?.map((b,index)=><span key={"btn"+index}><button  className="btn-outline-primary" onClick={b.onClick} disabled={b.disabled} >{b.text}</button>&nbsp;</span>)}
                    </div>
                </div>
                <div style={{padding:"15px"}}>
                  {children}
                </div>
            </div>
            
        </div>
    </>
  )
}

export default InfoBox